// extracted by mini-css-extract-plugin
module.exports = {"preset":"_1dq6T","activePreset":"_3xGSK"};